import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';
import { alpha, styled } from '@mui/material/styles';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import Collapse from '@mui/material/Collapse';
import { useSpring, animated, to, config } from '@react-spring/web';
import StringToReact from 'string-to-react';
import { useQuery } from '../hooks/useQuery';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import UploadIcon from '@mui/icons-material/Upload';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FormControl } from '@mui/material';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import AppBar from '@mui/material/AppBar';
import CircularProgress from '@mui/material/CircularProgress';
import CustomizedDialogs from '../components/ModalAlert';

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.4B8r3B4p7yhRXuBWLqsQ546WR43cqQwrbXMDFnBi6vSJBeif8tPW85a7r7DM961Jvk4hdryZoByEp8GC8HzsqJpRN4FxGM9-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon
      className="close"
      fontSize="inherit"
      style={{ width: 14, height: 14 }}
      {...props}
    >
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.4B8r3B4p7yhRXuBWLqsQ546WR43cqQwrbXMDFnBi6vSJBeif8tPW85a7r7DM961Jvk4hdryZoByEp8GC8HzsqJpRN4FxGM9281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

function TransitionComponent(props) {
  const style = useSpring({
    from: {
      opacity: 0,
      transform: 'translate3d(20px,0,0)',
    },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

TransitionComponent.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
};

const LayoutXml = () => {
  const {
    getFieldsTree,
    getFieldsNota,
    listarMunicipios,
    listarEstados,
    saveLayout,
    getLayout,
  } = useQuery();
  const [data, setData] = React.useState([]);
  const [colunasDb, setColunasDb] = React.useState([]);
  const [file, setFile] = React.useState(null);
  const inputFile = React.useRef(null);
  const [municipios, setMunicipios] = React.useState([]);
  const [estados, setEstados] = React.useState([]);
  const [codMunicipio, setCodMunicipio] = React.useState(0);
  const [estado, setEstado] = React.useState(0);
  const [show, setShow] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [naturezaOperacao, setNaturezaOperacao] = React.useState('servico');

  const getColunasNfs = async () => {
    const result = await getFieldsNota();
    setColunasDb(result.data.data);
  };

  const renderTree = () => {
    let transform = function (tagName) {
      if (tagName === 'StyledTreeItem') return StyledTreeItem;
      return null;
    };

    let view = '';
    if (data && data.length > 0) {
      data.forEach((result, index) => {
        view +=
          result.type === 'open'
            ? `<StyledTreeItem idx="${index}" defaultValue="${result.value}" nodeId="${result.level}" label="${result.tag}">`
            : result.type === 'complete'
            ? `<StyledTreeItem defaultValue="${result.value}" idx="${index}" nodeId="${result.level}.${index}" label="${result.tag}" type="${result.type}" />`
            : '</StyledTreeItem>';
      });
      return StringToReact(view, transform);
    } else {
      return StringToReact(
        `<StyledTreeItem nodeId="1" label=""></StyledTreeItem>`,
        transform,
      );
    }
  };

  const onChangeFile = async (event) => {
    if ([...event.target.files].length === 0) return;

    const f = event.target.files[0];

    if (f.type !== 'text/xml') {
      setMessage('Formato de aquivo inválido. Suportado apenas XML.');
      setType('error');
      setShow(true);
      return;
    }

    setFile(f);
    // setLoading(true);

    const formData = new FormData();
    formData.append('arquivo', f);

    try {
      const result = await getFieldsTree(formData);
      let dataset = result.data.data.map((res) => {
        res.value = '';
        return res;
      });
      setData(dataset);

      inputFile.current.value = '';
    } catch (error) {
      inputFile.current.value = '';
    }
  };

  const verificaLayout = async () => {
    if (estado === 0) return;

    let result = await getLayout({
      municipioId: codMunicipio || '',
      estado: estado,
      naturezaoperacao: naturezaOperacao,
    });
    if (
      result &&
      result.data &&
      result.data.data &&
      result.data.data.length > 0
    ) {
      setData(result.data.data);
      return true;
    } else {
      return false;
    }
  };

  const getMunicipios = async (estado_id) => {
    let result = await listarMunicipios(estado_id);
    setMunicipios(result && result.data && result.data.data);
  };

  const getEstados = async () => {
    let result = await listarEstados();
    setEstados(result.data.data);
  };

  const onChangeEstado = ({ target }) => {
    if (!target.value) return;
    setEstado(target.value);
    setCodMunicipio(0);

    if (naturezaOperacao === 'produto') {
      verificaLayout();
    }

    const estado = estados.find((estado) => estado.id === target.value);
    if (estado) {
      getMunicipios(estado.id);
    }
  };

  const onClickSave = async () => {
    if (naturezaOperacao === 'servico' && !codMunicipio) return;
    if (naturezaOperacao === 'produto' && !estado) return;

    setLoading(true);
    try {
      const result = await saveLayout({
        data,
        municipio_id: codMunicipio === 0 ? null : codMunicipio,
        estado,
        naturezaoperacao: naturezaOperacao,
      });
      setLoading(false);
      if (result && result.data && result.data.success) {
        setMessage('Layout criado com sucesso');
        setType('success');
        setShow(true);
      } else {
        setMessage('Houve um erro ao criar o layout');
        setType('error');
        setShow(true);
      }
    } catch (error) {
      setMessage('Houve um erro ao criar o layout');
      setType('error');
      setShow(true);
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getColunasNfs();
    getEstados();
  }, []);

  React.useEffect(() => {
    verificaLayout();
  }, [estado, naturezaOperacao, codMunicipio]);

  const StyledTreeItem = styled((props) => {
    if (props.type === 'complete') {
      return (
        <TreeItem
          nodeId={props.nodeId}
          children={props.children}
          className={props.className}
          label={
            <Grid style={{ margin: 2 }} container spacing={1}>
              <Grid item sm={4}>
                <TextField
                  disabled
                  style={{ width: '100%', height: 40 }}
                  id="outlined-basic"
                  value={props.label}
                  variant="contained"
                />
              </Grid>
              <Grid item sm={1} justifyContent={'center'} display="flex">
                <SyncAltIcon />
              </Grid>
              <Grid item sm={4}>
                <FormControl style={{ width: '100%' }}>
                  <Select
                    defaultValue={
                      props.defaultValue !== '' ? props.defaultValue : 0
                    }
                    style={{ height: 38 }}
                    onChange={(res) => {
                      data[props.idx].value = res.target.value;
                      // data.forEach((obj) => {
                      //   if (obj.tag === props.label) {
                      //     obj.value = res.target.value
                      //   }
                      // });
                    }}
                  >
                    <MenuItem disabled value={0}>
                      Selecione o campo relacionado
                    </MenuItem>
                    <MenuItem value={null}>Sem valor</MenuItem>
                    {colunasDb.map((field, index) => {
                      return (
                        <MenuItem key={index} value={field}>
                          {field}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          }
          TransitionComponent={TransitionComponent}
        />
      );
    } else {
      return <TreeItem {...props} TransitionComponent={TransitionComponent} />;
    }
  })(({ theme }) => ({}));

  return (
    <Box
      mt={8}
      sx={{ width: '100%', background: '#FAFCFF', minHeight: '100vh' }}
    >
      <AppBar position="static" color="primary" style={{ padding: 10 }}>
        <Grid container spacing={0}>
          <Grid item display="flex" alignItems="center">
            <SyncAltIcon
              sx={{
                fontSize: 40,
              }}
            />
            <span style={{ color: 'white', fontSize: 20 }}>Layout XML</span>
          </Grid>
        </Grid>
      </AppBar>
      <CustomizedDialogs
        content={message}
        btnTxt={'Ok'}
        type={type}
        onClick={() => setShow(false)}
        handleClose={setShow}
        visible={show}
      />
      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        <Grid item sm={4}>
          <FormControl style={{ width: '100%' }}>
            <Select
              defaultValue={naturezaOperacao}
              style={{ height: 42 }}
              onChange={({ target }) => {
                setNaturezaOperacao(target.value);
                setEstado(0);
              }}
            >
              <MenuItem value="servico">Serviço</MenuItem>
              <MenuItem value="produto">Produto</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item sm={4}>
          <FormControl style={{ width: '100%' }}>
            <Select
              defaultValue={0}
              style={{ height: 42 }}
              onChange={onChangeEstado}
            >
              <MenuItem disabled value={0}>
                Selecione o estado
              </MenuItem>
              {estados.map((estado) => {
                return (
                  <MenuItem key={`estado-xml-${estado.id}`} value={estado.id}>
                    {estado.nome}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item sm={4}>
          {naturezaOperacao !== 'produto' && (
            <FormControl style={{ width: '100%' }}>
              <Select
                defaultValue={codMunicipio}
                disabled={naturezaOperacao === 'produto'}
                style={{ height: 42 }}
                onChange={(e) => {
                  setCodMunicipio(e.target.value);
                }}
              >
                <MenuItem disabled value={0}>
                  Selecione o município da nota
                </MenuItem>
                {municipios.map((municipio, index) => {
                  return (
                    <MenuItem
                      key={municipio.codigo_municipio}
                      value={municipio.codigo_municipio}
                    >
                      {municipio.nome_municipio}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid item sm={6}>
          <TextField
            disabled
            style={{ width: '100%' }}
            id="outlined-basic"
            value={(file && file.name) || ''}
            placeholder="Importar arquivo XML"
            variant="outlined"
          />
        </Grid>
        <Grid item sm={2}>
          <Button
            style={{ width: '100%', height: 40 }}
            variant="outlined"
            component="label"
          >
            <UploadIcon />
            Importar
            <input
              onChange={onChangeFile}
              hidden
              ref={inputFile}
              accept="text/xml"
              type="file"
            />
          </Button>
        </Grid>
        <Grid item sm={12}>
          <TreeView
            aria-label="customized"
            defaultExpanded={['1', '2', '3', '4']}
            defaultCollapseIcon={<MinusSquare />}
            defaultExpandIcon={<PlusSquare />}
            defaultEndIcon={<CloseSquare />}
            sx={{ maxHeight: '100%', flexGrow: 1, maxWidth: '100%' }}
          >
            {renderTree()}
          </TreeView>
        </Grid>
        <Grid item sm={4}>
          <Button type="button" variant="contained" onClick={onClickSave}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {loading ? (
                <CircularProgress color={'inherit'} size={25} />
              ) : (
                <span>Salvar</span>
              )}
            </Box>
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LayoutXml;
